import { ModelBase } from "@shoothill/core";
import { action, computed, observable } from "mobx";
import { RDDV2FormDocumentModel, RDDV2DocumentDTO } from "../Common/RDDV2FormDocumentModel";
import { RDDV2FormFileModel, RDDV2FileDTO } from "../Common/RDDV2FormFileModel";
import { RDDV2CreateFormModel, RDDV2DTO } from "./RDDV2CreateFormModel";

export class RDDV2CreateFormItemsModel extends ModelBase<RDDV2CreateFormItemsModel> {
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_RDDV2S = [];
    public static readonly DEFAULT_RDDV2_DOCUMENTS = [];
    public static readonly DEFAULT_RDDV2_ATTACHMENTS = [];

    @observable
    public projectId: string = RDDV2CreateFormItemsModel.DEFAULT_PROJECT_ID;
    @observable
    public rddV2Documents: RDDV2FormDocumentModel[] = RDDV2CreateFormItemsModel.DEFAULT_RDDV2_DOCUMENTS;
    @observable
    public rddV2Items: RDDV2CreateFormModel[] = RDDV2CreateFormItemsModel.DEFAULT_RDDV2S;
    @observable
    public rddV2Attachments: RDDV2FormFileModel[] = RDDV2CreateFormItemsModel.DEFAULT_RDDV2_ATTACHMENTS;

    @action
    public reset = () => {
        this.projectId = RDDV2CreateFormItemsModel.DEFAULT_PROJECT_ID;
        this.rddV2Items.length = 0;
        this.rddV2Documents.length = 0;
        this.rddV2Attachments.length = 0;
    };

    @action
    public fromDto(dto: RDDV2StatusDTO): void {}

    public toDto(dto: RDDV2CreateFormItemsModel): void {}

    @action
    public fromRelatedDto(dto: RDDV2StatusDTO): void {}
}

export interface RDDV2StatusDTO {
    id: string;
    displayName: string;
}

export interface RDDV2ProjectDirectoryPersonDTO {
    id: string;
    displayName: string;
}

export interface RDDV2SupplierDTO {
    id: string;
    displayName: string;
}

export interface RDDV2CategoryDTO {
    id: string;
    displayName: string;
}

export interface RDDV2RequestedByDTO {
    id: string;
    displayName: string;
}

export interface RDDV2DarwinSupplierReferenceDTO {
    id: string;
    displayName: string;
}

export interface UpsertCategoryRDDV2sAndRelatedRequestDTO {
    projectId: string;
    rddV2Items: RDDV2DTO[];
    rddV2Documents: RDDV2DocumentDTO[];
    rddV2Attachments: RDDV2FileDTO[];
}

export interface RDDV2RelatedResultResponseDTO {
    suppliers: RDDV2SupplierDTO[];
    statuses: RDDV2StatusDTO[];
    projectDirectoryPersons: RDDV2ProjectDirectoryPersonDTO[];
    rddV2ProjectDetails: RDDV2ProjectDetailsDTO;
    categories: RDDV2CategoryDTO[];
}

export interface RDDV2ProjectDetailsDTO {
    projectReference: string;
    projectName: string;
}
